<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />


    <div v-show="!modoVisualizacao">
        <div class="form-edit-page row-space">
            <div class="row-start">
                <div class="form-item-char20"><GabineteAgendaStatusSelect :ckAddTodos="true" v-model:opcaoSelecionada="idStatus" /></div>
                <div class="form-item-rangedata"><DateRangeSelect :periodoInicial="'currentMonth'" v-model="dateRange" /></div>
                <button type="button" class="buttom-icon--search" @click="lerDados" />
                <button type="button" class="buttom-icon--close" @click="closeForm" />
            </div>
        </div>
        
        <table>
            <thead>
                <tr>
                    <th class="col-width-integer">Agenda</th>
                    <th class="col-width-date">Data</th>
                    <th class="col-width-char05">Hora</th>
                    <th>Assunto</th>
                    <th class="col-width-char30">Situação</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"  
                    @click="setVisualizar(obj)">
                    <td class="col-width-integer right">{{ Funcoes.formatInteger(obj.cdagenda) }}</td>
                    <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtagenda) }}</td>
                    <td class="col-width-char05 center">{{ Funcoes.formatTimeFromJson(obj.hragenda) }}</td>
                    <td>{{ obj.assunto }}</td>
                    <td class="col-width-char30">{{ obj.nmstatus }}</td>
                </tr>
            </tbody>
        </table>
        

        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>


    <div v-if="modoVisualizacao">
        <GabineteAgendaViewPage :idView="idView" @close="modoVisualizacao = false" @save="lerDados()" />
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericPost } from '@/funcoes/api'; 
import { globalStore } from '@/globals';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import GabineteAgendaViewPage from './GabineteAgendaViewPage.vue';
import GabineteAgendaStatusSelect from '@/selects/estaticos/GabineteAgendaStatusSelect.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close']);

const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const msgAlerta = ref(null);
const idStatus = ref(0);
const idView = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const lsDadosMain = ref([]);
const modoVisualizacao = ref(false);
const showPagination = ref(false);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);

const closeForm = () => {emit('close');}


async function lerDados() {
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await genericPost('/listas/gabinete_agenda', {
            idmunicipio: globalStore.idmunicipio,
            intparam1: idStatus.value,
            datainicial: dateRange.value.startDate, 
            datafinal:dateRange.value.endDate});
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}


const setVisualizar = (obj) =>{
    idView.value = obj.id;
    modoVisualizacao.value = true;
}

const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

onMounted(lerDados);
</script>
